import React from 'react'

const BookmarkIcon = ({ className, size = 20, currentColor = '#27272A' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill={currentColor}>
      <path d="M8.3335 15.8327L4.54183 17.7285C4.26405 17.8674 3.99322 17.857 3.72933 17.6973C3.46544 17.5375 3.3335 17.298 3.3335 16.9785V6.66602C3.3335 6.20768 3.49669 5.81532 3.82308 5.48893C4.14947 5.16254 4.54183 4.99935 5.00016 4.99935H11.6668C12.1252 4.99935 12.5175 5.16254 12.8439 5.48893C13.1703 5.81532 13.3335 6.20768 13.3335 6.66602V16.9785C13.3335 17.298 13.2016 17.5375 12.9377 17.6973C12.6738 17.857 12.4029 17.8674 12.1252 17.7285L8.3335 15.8327ZM5.00016 15.8118L7.54183 14.4368C7.79183 14.298 8.05572 14.2285 8.3335 14.2285C8.61127 14.2285 8.87516 14.298 9.12516 14.4368L11.6668 15.8118V6.66602H5.00016V15.8118ZM15.8335 14.9993C15.5974 14.9993 15.3995 14.9195 15.2397 14.7598C15.08 14.6 15.0002 14.4021 15.0002 14.166V3.33268H6.66683C6.43072 3.33268 6.2328 3.25282 6.07308 3.0931C5.91336 2.93338 5.8335 2.73546 5.8335 2.49935C5.8335 2.26324 5.91336 2.06532 6.07308 1.9056C6.2328 1.74588 6.43072 1.66602 6.66683 1.66602H15.0002C15.4585 1.66602 15.8509 1.82921 16.1772 2.1556C16.5036 2.48199 16.6668 2.87435 16.6668 3.33268V14.166C16.6668 14.4021 16.587 14.6 16.4272 14.7598C16.2675 14.9195 16.0696 14.9993 15.8335 14.9993Z" fill={currentColor} />
    </svg>
  )
}

export default BookmarkIcon
